import { safeApiRequest } from './apiClient';

const ENDPOINT = '/api/admin/egitim-ts-kayit';

export const fetchEgitimTsKayitDurum = () =>
  safeApiRequest(`${ENDPOINT}/durum`, { method: 'GET', skipCsrf: true });

export const updateEgitimTsKayitGrup = (teknikServisIds) =>
  safeApiRequest(`${ENDPOINT}/grup`, {
    method: 'PUT',
    body: { teknikServisIds },
  });

export const runEgitimTsKayitOlustur = () =>
  safeApiRequest(`${ENDPOINT}/olustur`, { method: 'POST', body: {}, timeoutMs: 120000 });
